export default __webpack_public_path__ + "static/media/next.aa89ad1f.svg";